export const MaxFileSize = 1073741824;
export const MaxQueueLength = 100;
